// extracted by mini-css-extract-plugin
export default {"logoPlayer":"logoPlayer__nAOYw","noLink":"noLink__+RWHx","hide":"hide__bNvJb","hideVertical":"hideVertical__atBWR","logo":"logo__0T68b","noCustomLogo":"noCustomLogo__5DZ0+"};